import { render } from "./RegisterPage.vue?vue&type=template&id=3a2d95ee&scoped=true&bindings={}"
import script from "./RegisterPage.vue?vue&type=script&lang=ts"
export * from "./RegisterPage.vue?vue&type=script&lang=ts"

import "./RegisterPage.vue?vue&type=style&index=0&id=3a2d95ee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3a2d95ee"

export default script